<template>
  <!--停机升级公告页（全站拦截后展示，PC / 移动端自适应）-->
  <div class="maintenance-page">
    <div class="maintenance-card">
      <div class="maintenance-icon">
        <svg viewBox="0 0 1024 1024" aria-hidden="true">
          <path
            fill="#c6a056"
            d="M512 64a448 448 0 1 0 0 896 448 448 0 0 0 0-896zm0 64a384 384 0 1 1 0 768 384 384 0 0 1 0-768zm0 128a32 32 0 0 1 32 32v224h160a32 32 0 1 1 0 64H512a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32z"
          />
        </svg>
      </div>

      <h1 class="maintenance-title">{{ info.title }}</h1>

      <p class="maintenance-time">{{ timeText }}</p>

      <p class="maintenance-content">{{ info.content }}</p>

      <button class="maintenance-btn" type="button" @click="reload">刷新重试</button>

      <p class="maintenance-tip">感谢您的理解与支持！</p>
    </div>
  </div>
</template>

<script>
import { getMaintenanceState } from '@/utils/maintenance'

export default {
  name: 'Maintenance',
  data() {
    return {
      info: { ...getMaintenanceState() },
    }
  },
  computed: {
    timeText() {
      const { startTime, endTime } = this.info
      if (startTime && endTime) {
        return `维护时间：${startTime} 至 ${endTime}`
      }
      return '预计恢复时间请以官方通知为准'
    },
  },
  methods: {
    reload() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
/* 本页面不在 px-to-viewport 的转换名单内，因此统一用 vw + clamp 做自适应，
   同一份样式在 PC（宽屏）和移动端（窄屏）都能平滑缩放 */
.maintenance-page {
  min-height: 100vh;
  min-height: 100dvh; /* 移动端浏览器地址栏收起/展开时不出现裁切 */
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: clamp(16px, 3vw, 40px) 20px;
  padding-bottom: calc(clamp(16px, 3vw, 40px) + env(safe-area-inset-bottom, 0px));
  overflow-x: hidden;
  background: radial-gradient(circle at 50% 20%, #23232a 0%, #0d0d0f 70%);
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
}

.maintenance-card {
  width: 100%;
  max-width: 560px;
  padding: clamp(28px, 3vw, 48px) clamp(20px, 2.5vw, 40px) clamp(24px, 2.5vw, 40px);
  box-sizing: border-box;
  text-align: center;
  background: #16161a;
  border: 1px solid rgba(198, 160, 86, 0.35);
  border-radius: clamp(12px, 1vw, 16px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
}

.maintenance-icon {
  width: clamp(64px, 5.5vw, 88px);
  height: clamp(64px, 5.5vw, 88px);
  margin: 0 auto clamp(14px, 1.4vw, 20px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(198, 160, 86, 0.1);
  border: 1px solid rgba(198, 160, 86, 0.3);
  animation: maintenance-spin 6s linear infinite;
}

.maintenance-icon svg {
  width: 58%;
  height: 58%;
}

@keyframes maintenance-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.maintenance-title {
  margin: 0 0 clamp(8px, 0.8vw, 12px);
  font-size: clamp(18px, 1.6vw, 24px);
  font-weight: 600;
  letter-spacing: 1px;
  color: #f5e6c8;
}

.maintenance-time {
  margin: 0 0 clamp(14px, 1.4vw, 20px);
  font-size: clamp(12px, 0.9vw, 14px);
  color: #c6a056;
}

.maintenance-content {
  margin: 0 0 clamp(22px, 2vw, 28px);
  font-size: clamp(13px, 0.95vw, 15px);
  line-height: 1.9;
  text-align: left;
  color: #b9b9c0;
  word-break: break-word;
}

.maintenance-btn {
  min-width: 140px;
  padding: 12px 28px;
  font-size: clamp(14px, 0.95vw, 15px);
  font-family: inherit;
  color: #16161a;
  cursor: pointer;
  background: linear-gradient(90deg, #d8b968 0%, #c6a056 100%);
  border: none;
  border-radius: 999px;
  transition: opacity 0.2s;
  -webkit-tap-highlight-color: transparent;
}

.maintenance-btn:hover,
.maintenance-btn:active {
  opacity: 0.88;
}

.maintenance-tip {
  margin: clamp(14px, 1.4vw, 20px) 0 0;
  font-size: clamp(12px, 0.8vw, 13px);
  color: #6f6f78;
}

/* ============ 移动端（窄屏）适配 ============ */
@media (max-width: 768px) {
  .maintenance-page {
    padding: 20px 16px;
    padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
  }

  .maintenance-card {
    max-width: 100%;
    padding: 32px 22px 26px;
    border-radius: 12px;
  }

  /* 移动端字号回到 375 设计稿的阅读尺寸，不随宽屏 vw 缩放 */
  .maintenance-title {
    font-size: 19px;
  }

  .maintenance-time {
    font-size: 13px;
  }

  .maintenance-content {
    font-size: 14px;
    text-align: center;
  }

  .maintenance-btn {
    width: 100%;
    padding: 13px 0;
    font-size: 15px;
  }

  .maintenance-tip {
    font-size: 12px;
  }
}
</style>
